"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get _transformSubmittedFormDataForEmail () {
        return _transformSubmittedFormDataForEmail;
    },
    get compareOperationCode () {
        return compareOperationCode;
    },
    get getAffectedColumns () {
        return getAffectedColumns;
    },
    get handleHttpWebHook () {
        return handleHttpWebHook;
    },
    get invokeWebhook () {
        return invokeWebhook;
    },
    get operationArrToCode () {
        return operationArrToCode;
    },
    get operationCodeToArr () {
        return operationCodeToArr;
    },
    get parseBody () {
        return parseBody;
    },
    get sanitizeUserForHook () {
        return sanitizeUserForHook;
    },
    get transformDataForMailRendering () {
        return transformDataForMailRendering;
    },
    get validateCondition () {
        return validateCondition;
    }
});
const _common = require("@nestjs/common");
const _axios = /*#__PURE__*/ _interop_require_default(require("axios"));
const _dayjs = /*#__PURE__*/ _interop_require_default(require("dayjs"));
const _isBetween = /*#__PURE__*/ _interop_require_default(require("dayjs/plugin/isBetween"));
const _isSameOrAfter = /*#__PURE__*/ _interop_require_default(require("dayjs/plugin/isSameOrAfter"));
const _isSameOrBefore = /*#__PURE__*/ _interop_require_default(require("dayjs/plugin/isSameOrBefore"));
const _handlebars = /*#__PURE__*/ _interop_require_default(require("handlebars"));
const _handlebarshelpersv2 = /*#__PURE__*/ _interop_require_default(require("handlebars-helpers-v2"));
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
const _utils = require("~/utils");
const _webhookinvoker = require("~/utils/webhook-invoker");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
(0, _handlebarshelpersv2.default)({
    handlebars: _handlebars.default
});
_dayjs.default.extend(_isBetween.default);
_dayjs.default.extend(_isSameOrBefore.default);
_dayjs.default.extend(_isSameOrAfter.default);
_handlebars.default.registerHelper('json', function(context, pretty = false) {
    if (pretty === true || pretty === 'true') {
        // Pretty print with 2-space indentation
        return JSON.stringify(context, null, 2);
    }
    return JSON.stringify(context);
});
const logger = new _common.Logger('webhookHelpers');
function parseBody(template, data) {
    if (!template) {
        return template;
    }
    try {
        return _handlebars.default.compile(template, {
            noEscape: true
        })({
            data,
            event: data
        });
    } catch (e) {
        // if parsing fails then return the original template
        return template;
    }
}
async function validateCondition(context, filters, data = {}, { client, skipFetchingChildren = false }) {
    if (!filters.length) {
        return true;
    }
    let isValid = null;
    for (const _filter of filters){
        const filter = _filter instanceof _models.Filter ? _filter : new _models.Filter(_filter);
        let res;
        if (filter.is_group) {
            // If skipFetchingChildren is true, only use children from the object
            // This is useful for filters stored in JSON (like workflow configs) that aren't in the database
            filter.children = skipFetchingChildren ? filter.children || [] : filter.children || await filter.getChildren(context);
            res = await validateCondition(context, filter.children, data, {
                client,
                skipFetchingChildren
            });
        } else {
            const column = await filter.getColumn(context);
            const field = column.title;
            let val = data[field];
            if ([
                _nocodbsdk.UITypes.Date,
                _nocodbsdk.UITypes.DateTime,
                _nocodbsdk.UITypes.CreatedTime,
                _nocodbsdk.UITypes.LastModifiedTime
            ].includes(column.uidt) && ![
                'empty',
                'blank',
                'notempty',
                'notblank'
            ].includes(filter.comparison_op)) {
                var _column_meta;
                const dateFormat = client === 'mysql2' ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD HH:mm:ssZ';
                let now = (0, _dayjs.default)(new Date());
                const dateFormatFromMeta = column == null ? void 0 : (_column_meta = column.meta) == null ? void 0 : _column_meta.date_format;
                const dataVal = val;
                let filterVal = filter.value;
                if (dateFormatFromMeta && (0, _nocodbsdk.isDateMonthFormat)(dateFormatFromMeta)) {
                    // reset to 1st
                    now = (0, _dayjs.default)(now).date(1);
                    if (val) val = (0, _dayjs.default)(val).date(1);
                }
                if (filterVal) res = (0, _dayjs.default)(filterVal).isSame(dataVal, 'day');
                // handle sub operation
                switch(filter.comparison_sub_op){
                    case 'today':
                        filterVal = now;
                        break;
                    case 'tomorrow':
                        filterVal = now.add(1, 'day');
                        break;
                    case 'yesterday':
                        filterVal = now.add(-1, 'day');
                        break;
                    case 'oneWeekAgo':
                        filterVal = now.add(-1, 'week');
                        break;
                    case 'oneWeekFromNow':
                        filterVal = now.add(1, 'week');
                        break;
                    case 'oneMonthAgo':
                        filterVal = now.add(-1, 'month');
                        break;
                    case 'oneMonthFromNow':
                        filterVal = now.add(1, 'month');
                        break;
                    case 'daysAgo':
                        if (!filterVal) return;
                        filterVal = now.add(-filterVal, 'day');
                        break;
                    case 'daysFromNow':
                        if (!filterVal) return;
                        filterVal = now.add(filterVal, 'day');
                        break;
                    case 'exactDate':
                        if (!filterVal) return;
                        break;
                    // sub-ops for `isWithin` comparison
                    case 'pastWeek':
                        filterVal = now.add(-1, 'week');
                        break;
                    case 'pastMonth':
                        filterVal = now.add(-1, 'month');
                        break;
                    case 'pastYear':
                        filterVal = now.add(-1, 'year');
                        break;
                    case 'nextWeek':
                        filterVal = now.add(1, 'week');
                        break;
                    case 'nextMonth':
                        filterVal = now.add(1, 'month');
                        break;
                    case 'nextYear':
                        filterVal = now.add(1, 'year');
                        break;
                    case 'pastNumberOfDays':
                        if (!filterVal) return;
                        filterVal = now.add(-filterVal, 'day');
                        break;
                    case 'nextNumberOfDays':
                        if (!filterVal) return;
                        filterVal = now.add(filterVal, 'day');
                        break;
                }
                if (dataVal) {
                    switch(filter.comparison_op){
                        case 'eq':
                            res = (0, _dayjs.default)(dataVal).isSame(filterVal, 'day');
                            break;
                        case 'neq':
                            res = !(0, _dayjs.default)(dataVal).isSame(filterVal, 'day');
                            break;
                        case 'gt':
                            res = (0, _dayjs.default)(dataVal).isAfter(filterVal, 'day');
                            break;
                        case 'lt':
                            res = (0, _dayjs.default)(dataVal).isBefore(filterVal, 'day');
                            break;
                        case 'lte':
                        case 'le':
                            res = (0, _dayjs.default)(dataVal).isSameOrBefore(filterVal, 'day');
                            break;
                        case 'gte':
                        case 'ge':
                            res = (0, _dayjs.default)(dataVal).isSameOrAfter(filterVal, 'day');
                            break;
                        case 'empty':
                        case 'blank':
                            res = dataVal === '' || dataVal === null || dataVal === undefined;
                            break;
                        case 'notempty':
                        case 'notblank':
                            res = !(dataVal === '' || dataVal === null || dataVal === undefined);
                            break;
                        case 'isWithin':
                            {
                                let now = (0, _dayjs.default)(new Date()).format(dateFormat).toString();
                                now = column.uidt === _nocodbsdk.UITypes.Date ? now.substring(0, 10) : now;
                                switch(filter.comparison_sub_op){
                                    case 'pastWeek':
                                    case 'pastMonth':
                                    case 'pastYear':
                                    case 'pastNumberOfDays':
                                        res = (0, _dayjs.default)(dataVal).isBetween(filterVal, now, 'day');
                                        break;
                                    case 'nextWeek':
                                    case 'nextMonth':
                                    case 'nextYear':
                                    case 'nextNumberOfDays':
                                        res = (0, _dayjs.default)(dataVal).isBetween(now, filterVal, 'day');
                                        break;
                                }
                            }
                    }
                }
            } else {
                switch(typeof filter.value){
                    case 'boolean':
                        val = !!data[field];
                        break;
                    case 'number':
                        val = +data[field];
                        break;
                }
                if ([
                    _nocodbsdk.UITypes.User,
                    _nocodbsdk.UITypes.CreatedBy,
                    _nocodbsdk.UITypes.LastModifiedBy
                ].includes(column.uidt)) {
                    var _ref;
                    var _data_field, _filter_value;
                    const userIds = Array.isArray(data[field]) ? data[field].map((user)=>user.id) : ((_data_field = data[field]) == null ? void 0 : _data_field.id) ? [
                        data[field].id
                    ] : [];
                    const filterValues = (_ref = (_filter_value = filter.value) == null ? void 0 : _filter_value.split(',').map((v)=>v.trim())) != null ? _ref : [];
                    switch(filter.comparison_op){
                        case 'anyof':
                            res = userIds.some((id)=>filterValues.includes(id));
                            break;
                        case 'nanyof':
                            res = !userIds.some((id)=>filterValues.includes(id));
                            break;
                        case 'allof':
                            res = filterValues.every((id)=>userIds.includes(id));
                            break;
                        case 'nallof':
                            res = !filterValues.every((id)=>userIds.includes(id));
                            break;
                        case 'empty':
                        case 'blank':
                            res = userIds.length === 0;
                            break;
                        case 'notempty':
                        case 'notblank':
                            res = userIds.length > 0;
                            break;
                        default:
                            res = false; // Unsupported operation for User fields
                    }
                } else {
                    const isBlank = (dataValue)=>{
                        if (dataValue === '' || dataValue === null || dataValue === undefined) {
                            return true;
                        } else if (Array.isArray(dataValue)) {
                            return dataValue.filter((v)=>!isBlank(v)).length === 0;
                        }
                        return false;
                    };
                    switch(filter.comparison_op){
                        case 'eq':
                            res = val == filter.value;
                            break;
                        case 'neq':
                            res = val != filter.value;
                            break;
                        case 'like':
                            var _filter_value1, _data_field_toString_toLowerCase, _data_field_toString, _data_field_toString1, _data_field1;
                            res = ((_data_field1 = data[field]) == null ? void 0 : (_data_field_toString1 = _data_field1.toString) == null ? void 0 : (_data_field_toString = _data_field_toString1.call(_data_field1)) == null ? void 0 : (_data_field_toString_toLowerCase = _data_field_toString.toLowerCase()) == null ? void 0 : _data_field_toString_toLowerCase.indexOf((_filter_value1 = filter.value) == null ? void 0 : _filter_value1.toLowerCase())) > -1;
                            break;
                        case 'nlike':
                            var _filter_value2, _data_field_toString_toLowerCase1, _data_field_toString2, _data_field_toString3, _data_field2;
                            res = ((_data_field2 = data[field]) == null ? void 0 : (_data_field_toString3 = _data_field2.toString) == null ? void 0 : (_data_field_toString2 = _data_field_toString3.call(_data_field2)) == null ? void 0 : (_data_field_toString_toLowerCase1 = _data_field_toString2.toLowerCase()) == null ? void 0 : _data_field_toString_toLowerCase1.indexOf((_filter_value2 = filter.value) == null ? void 0 : _filter_value2.toLowerCase())) === -1;
                            break;
                        case 'empty':
                        case 'blank':
                            res = isBlank(data[field]);
                            break;
                        case 'notempty':
                        case 'notblank':
                            res = !isBlank(data[field]);
                            break;
                        case 'checked':
                            res = !!data[field];
                            break;
                        case 'notchecked':
                            res = !data[field];
                            break;
                        case 'null':
                            res = data[field] === null;
                            break;
                        case 'notnull':
                            res = data[field] !== null;
                            break;
                        case 'allof':
                            var _ref1;
                            var _filter_value3;
                            res = ((_ref1 = (_filter_value3 = filter.value) == null ? void 0 : _filter_value3.split(',').map((item)=>item.trim())) != null ? _ref1 : []).every((item)=>{
                                var _ref;
                                var _data_field;
                                return ((_ref = (_data_field = data[field]) == null ? void 0 : _data_field.split(',')) != null ? _ref : []).includes(item);
                            });
                            break;
                        case 'anyof':
                            var _ref2;
                            var _filter_value4;
                            res = ((_ref2 = (_filter_value4 = filter.value) == null ? void 0 : _filter_value4.split(',').map((item)=>item.trim())) != null ? _ref2 : []).some((item)=>{
                                var _ref;
                                var _data_field;
                                return ((_ref = (_data_field = data[field]) == null ? void 0 : _data_field.split(',')) != null ? _ref : []).includes(item);
                            });
                            break;
                        case 'nallof':
                            var _ref3;
                            var _filter_value5;
                            res = !((_ref3 = (_filter_value5 = filter.value) == null ? void 0 : _filter_value5.split(',').map((item)=>item.trim())) != null ? _ref3 : []).every((item)=>{
                                var _ref;
                                var _data_field;
                                return ((_ref = (_data_field = data[field]) == null ? void 0 : _data_field.split(',')) != null ? _ref : []).includes(item);
                            });
                            break;
                        case 'nanyof':
                            var _ref4;
                            var _filter_value6;
                            res = !((_ref4 = (_filter_value6 = filter.value) == null ? void 0 : _filter_value6.split(',').map((item)=>item.trim())) != null ? _ref4 : []).some((item)=>{
                                var _ref;
                                var _data_field;
                                return ((_ref = (_data_field = data[field]) == null ? void 0 : _data_field.split(',')) != null ? _ref : []).includes(item);
                            });
                            break;
                        case 'lt':
                            res = +data[field] < +filter.value;
                            break;
                        case 'lte':
                        case 'le':
                            res = +data[field] <= +filter.value;
                            break;
                        case 'gt':
                            res = +data[field] > +filter.value;
                            break;
                        case 'gte':
                        case 'ge':
                            res = +data[field] >= +filter.value;
                            break;
                    }
                }
            }
        }
        switch(filter.logical_op){
            case 'or':
                isValid = isValid || !!res;
                break;
            case 'not':
                isValid = isValid && !res;
                break;
            case 'and':
            default:
                isValid = (isValid != null ? isValid : true) && res;
                break;
        }
    }
    return isValid;
}
function sanitizeUserForHook(user) {
    if (!user || !user.id || !user.email) return null;
    return {
        id: user.id,
        email: user.email,
        display_name: user.display_name
    };
}
function extractReqPayloadForLog(reqPayload, response) {
    var _response_config;
    return _extends({}, reqPayload, {
        headers: _extends({}, (response == null ? void 0 : (_response_config = response.config) == null ? void 0 : _response_config.headers) || {}, reqPayload.headers || {}),
        // exclude http/https agent filters
        httpAgent: undefined,
        httpsAgent: undefined,
        timeout: undefined,
        withCredentials: undefined
    });
}
function extractResPayloadForLog(response) {
    return {
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
        data: response.data
    };
}
async function handleHttpWebHook({ reqPayload }) {
    const response = await (0, _axios.default)(reqPayload);
    return {
        response,
        requestPayload: extractReqPayloadForLog(reqPayload, response),
        responsePayload: extractResPayloadForLog(response)
    };
}
async function invokeWebhook(context, param) {
    // backward compatibility
    return new _webhookinvoker.WebhookInvoker().invoke(context, param);
}
function _transformSubmittedFormDataForEmail(data, // @ts-ignore
formView, // @ts-ignore
columns) {
    const transformedData = _extends({}, data);
    for (const col of columns){
        if (col.uidt === 'Attachment') {
            if (typeof transformedData[col.title] === 'string') {
                transformedData[col.title] = JSON.parse(transformedData[col.title]);
            }
            transformedData[col.title] = (transformedData[col.title] || []).map((attachment)=>{
                return attachment.title;
            }).join('<br/>');
        } else if (transformedData[col.title] && typeof transformedData[col.title] === 'object') {
            transformedData[col.title] = JSON.stringify(transformedData[col.title]);
        }
    }
    return transformedData;
}
function transformDataForMailRendering(data, columns, source, model, models) {
    const transformedData = [];
    columns.map((col)=>{
        let serializedValue;
        try {
            serializedValue = _nocodbsdk.ColumnHelper.parsePlainCellValue(data[col.title], {
                col,
                isMysql: ()=>source.type.startsWith('mysql'),
                isPg: ()=>source.type === 'pg',
                isXcdbBase: ()=>!!source.isMeta(),
                meta: model,
                metas: models
            });
            if (col.uidt === 'Attachment') {
                let attachments = data[col.title] || [];
                if (typeof data[col.title] === 'string') {
                    try {
                        attachments = JSON.parse(data[col.title]);
                    } catch (e) {
                        attachments = [];
                    }
                }
                serializedValue = Array.isArray(attachments) ? attachments.map((attachment)=>(attachment == null ? void 0 : attachment.title) || '').filter(Boolean).join(', ') : '';
            }
        } catch (error) {
            var _data_col_title;
            logger.error(`Error processing column ${col.title}:`, error);
            serializedValue = ((_data_col_title = data[col.title]) == null ? void 0 : _data_col_title.toString()) || '';
        }
        transformedData.push({
            parsedValue: serializedValue,
            uidt: col.uidt,
            columnTitle: col.title
        });
    });
    return transformedData;
}
function operationArrToCode(value) {
    let result = 0;
    for (const operation of value){
        result += _nocodbsdk.HookOperationCode[operation];
    }
    return result.toString();
}
function operationCodeToArr(code) {
    const numberCode = typeof code === 'number' ? code : Number(code);
    const result = [];
    for (const operation of Object.keys(_nocodbsdk.HookOperationCode)){
        const operationCode = _nocodbsdk.HookOperationCode[operation];
        if ((numberCode & operationCode) === operationCode) {
            result.push(operation);
        }
    }
    return result;
}
function compareOperationCode(param) {
    const numberCode = typeof param.code === 'number' ? param.code : Number(param.code);
    return (_nocodbsdk.HookOperationCode[param.operation] & numberCode) === _nocodbsdk.HookOperationCode[param.operation];
}
async function getAffectedColumns(context, { hookName, prevData, newData, model }) {
    if (hookName !== 'after.update' && hookName !== 'after.bulkUpdate') {
        return undefined;
    }
    let affectedCols = [];
    if (typeof prevData === 'undefined' || prevData === null) {
        return undefined;
    }
    const compareSingle = (prev, next)=>{
        const updatePayload = (0, _utils.populateUpdatePayloadDiff)({
            prev,
            next,
            keepUnderModified: true
        });
        if (updatePayload) {
            affectedCols = affectedCols.concat(Object.keys(updatePayload.modifications));
        }
    };
    if (Array.isArray(prevData)) {
        for(let i = 0; i < prevData.length; i++){
            compareSingle(prevData[i], newData[i]);
        }
    } else {
        compareSingle(prevData, newData);
    }
    if (affectedCols.length) {
        affectedCols = [
            ...new Set(affectedCols)
        ];
        const columns = await model.getColumns(context);
        return affectedCols.map((title)=>{
            var _columns_find;
            return (_columns_find = columns.find((col)=>col.title === title)) == null ? void 0 : _columns_find.id;
        }).filter(Boolean);
    } else {
        return undefined;
    }
}
